import _extends from "@babel/runtime/helpers/esm/extends";
import React, { useContext } from 'react';
import CalendarPickerContext from '../context/CalendarPickerContext';
import Calendar from '../date-panel';
import { CALENDAR_POSITION } from '../utils/constants';
var SingleCalendar = function SingleCalendar(props) {
  var _useContext = useContext(CalendarPickerContext),
    activeStartDateStore = _useContext.activeStartDateStore,
    viewStore = _useContext.viewStore,
    viewDispatch = _useContext.viewDispatch,
    activeStartDateDispatch = _useContext.activeStartDateDispatch,
    value = _useContext.value,
    valueDispatch = _useContext.valueDispatch,
    momentUtils = _useContext.momentUtils,
    keyboardControlStore = _useContext.keyboardControlStore,
    keyboardControlAreaDispatch = _useContext.keyboardControlAreaDispatch,
    inputValueDispatch = _useContext.inputValueDispatch,
    openStatusDispatch = _useContext.openStatusDispatch,
    inputRefList = _useContext.inputRefList,
    dateValidator = _useContext.dateValidator,
    setIsUsingKeyboard = _useContext.setIsUsingKeyboard;
  return /*#__PURE__*/React.createElement(Calendar, _extends({}, props, {
    inputRefList: inputRefList,
    openStatusDispatch: openStatusDispatch,
    momentUtils: momentUtils,
    value: value,
    valueDispatch: valueDispatch,
    activeStartDate: activeStartDateStore.activeStartDateLeft,
    activeStartDateDispatch: activeStartDateDispatch,
    view: viewStore.view,
    viewDispatch: viewDispatch,
    inputValueDispatch: inputValueDispatch,
    keyboardNavDate: keyboardControlStore.keyboardNavDate,
    keyboardControlArea: keyboardControlStore.keyboardControlArea,
    keyboardControlAreaDispatch: keyboardControlAreaDispatch,
    calendarPosition: CALENDAR_POSITION.LEFT,
    showNavigationPrevNextBtn: true,
    dateValidator: dateValidator,
    setIsUsingKeyboard: setIsUsingKeyboard
  }));
};
export default SingleCalendar;